export default __webpack_public_path__ + "static/media/digital fab.7e1001f0.png";